import React from 'react';
import MuiToolbar from '@material-ui/core/Toolbar';

const Toolbar = props => <MuiToolbar {...props} />;

Toolbar.muiName = 'Toolbar';

export default Toolbar;
